module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/buttons/button-medium-border-180.png"+" 180w",
        images: [{path: __webpack_public_path__ + "assets/images/buttons/button-medium-border-180.png",width: 180,height: 50}],
        src: __webpack_public_path__ + "assets/images/buttons/button-medium-border-180.png",
        toString: function(){return __webpack_public_path__ + "assets/images/buttons/button-medium-border-180.png"},
        
        width: 180,
        height: 50
      }